module.exports = {
  // url: "http://localhost:2323",
  url: "https://kaivallaksh.raghuveerinfotech.com",
};
